export default "__VITE_ASSET__4cc9a09a__"